import { Flex, Layout } from "antd";
import { styled } from "styled-components";

const { Sider } = Layout;

export const SupplierPagesHomeWrap = styled(Flex)`
  width: 100%;
  height: 100%;
  overflow: hidden;

  background-color: #FFFFFF;
  background-image: linear-gradient(180deg, #FFFFFF 0%, #F1F9F7FF 50%, #F5FBF1FF 100%);

  & .ant-layout {
    background: unset;
  }

  & .ant-layout-sider {
    background: unset;
  }
`

export const SupplierSiderWrap = styled(Sider)`
  height: 100%;
  border-right: 1px solid #e8e8e8;
  overflow: auto;

  & .title--wrap {
    height: 60px;
    align-items: center;
    text-align: center;
    font-size: 30px;
    line-height: 60px;
    font-weight: 500;
    border-bottom: 1px solid #e8e8e8;
    margin-left: 10px;
  }

  & .ant-menu {
    background: unset;
  }

  & .supplier-opt-wrap{
    width: 200px;
    display: flex;
    justify-content: space-evenly;
    align-items: center;    
    position: fixed;
    left: 0;
    bottom: 20px;
    padding: 8px 0;
    background-color: rgba(0,0,0,0.06);

    .supplier-opt-drop{
      cursor: pointer;
    }
  }

`